export default "__VITE_ASSET__j2aKVNHZ__"